// extracted by mini-css-extract-plugin
export default {"tableContainer":"StyledTableContainer_tableContainer__bDrF6"};